export const geojson = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        point_code: "L001",
        event_dates: "19 Nov 2017",
        location_name: "Khirbet al-Halawah",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Two structures demolished leaving two families homeless.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=206191;https://www.youtube.com/watch?v=pBEQg1JVSQc"
      },
      geometry: { type: "Point", coordinates: [35.157752, 31.364836] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L002",
        event_dates: "17 Jun 2019",
        location_name: "Khirbet al-Halawah",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Three cement structures demolished leaving three families, totaling 21 people, homeless.",
        sources:
          "https://www.btselem.org/video/20190620_ca_demolishes_homes_in_masafer_yata#full;https://www.youtube.com/watch?v=cLbMzojO99A"
      },
      geometry: { type: "Point", coordinates: [35.157141, 31.365967] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L003",
        event_dates: "9 Oct 2018",
        location_name: "Khirbet al-Halawah",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Three dwellings donated by humanitarian aid organization demolished, leaving 21 people homeless.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212149;https://www.youtube.com/watch?v=ItIO60d1_ZU"
      },
      geometry: { type: "Point", coordinates: [35.158738, 31.365994] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L004",
        event_dates: "19 Jun 2016",
        location_name: "Khirbet Wadi Ejheish",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Two family homes and two livestock pens demolished, affecting 21 people.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=206240&community=&page=21;https://www.youtube.com/watch?v=B1U13IBwqTY;https://web.archive.org/web/20171016003722/http://rhr.org.il/heb/2016/06/24760/"
      },
      geometry: { type: "Point", coordinates: [35.100659, 31.381562] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L005",
        event_dates: "29 Dec 2020",
        location_name: "Khirbet Wadi Ejheish",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Prefabricated home demolished, displacing a family of eight.",
        sources:
          "https://www.btselem.org/video/20201231_israel_rushes_to_demolish_more_homes_this_year#full;https://www.youtube.com/watch?v=lLNKRMw82Vg"
      },
      geometry: { type: "Point", coordinates: [35.101226, 31.382523] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L006",
        event_dates: "29 Sep 2020",
        location_name: "Khirbet Shaab al-Butum",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Two cinder block structures demolished that were home to two families, totaling 14 people.",
        sources:
          "https://twitter.com/Paltodaytv/status/1311218428615692290;https://www.btselem.org/facing_expulsion_blog?nid=213106;https://www.youtube.com/watch?v=cgjKjQAeBb0"
      },
      geometry: { type: "Point", coordinates: [35.13646, 31.394167] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L007",
        event_dates: "2 Mar 2021",
        location_name: "Khirbet Khilet a-Dabe'",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Two structures demolished that housed two families, totaling 11 people.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213371;https://www.youtube.com/watch?v=-xDauzegh_Q;https://www.facebook.com/watch/?v=280461776775477;https://www.gettyimages.com/detail/news-photo/israeli-machinery-demolish-a-palestinian-house-located-news-photo/1231469217?adppopup=true"
      },
      geometry: { type: "Point", coordinates: [35.158212, 31.39462] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L008",
        event_dates: "17 Jun 2019",
        location_name: "Khirbet Khilet a-Dabe'",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "One cement structure demolished that was home to a family of 12.",
        sources:
          "https://www.btselem.org/video/20190620_ca_demolishes_homes_in_masafer_yata#full;https://www.youtube.com/watch?v=WSVhzOYSPco;http://poica.org/2019/06/%D8%A7%D9%84%D8%A7%D8%AD%D8%AA%D9%84%D8%A7%D9%84-%D9%8A%D9%87%D8%AF%D9%85-%D9%85%D8%B3%D9%83%D9%86%D8%A7%D9%8B-%D9%81%D9%8A-%D9%82%D8%B1%D9%8A%D8%A9-%D8%AE%D9%84%D8%A9-%D8%A7%D9%84%D8%B6%D8%A8%D8%B9/;https://twitter.com/alrayps/status/1140537264331722757"
      },
      geometry: { type: "Point", coordinates: [35.157399, 31.393896] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L009",
        event_dates: "11 Sep 2019",
        location_name: "Khirbet Khilet a-Dabe'",
        type: "Demolition",
        structure_types: "Residential; WASH",
        notes:
          "Two structures used as housing for two families totaling nine people demolished, along with a water cistern.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212514;https://www.youtube.com/watch?v=XVEDJKdxkGg"
      },
      geometry: { type: "Point", coordinates: [35.158018, 31.393164] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L010",
        event_dates: "2 Nov 2020",
        location_name: "Ghzewi",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Home under construction demolished that was intended to house a family of seven.",
        sources:
          "https://www.btselem.org/video/20201112_ghzewi_demolition;https://www.youtube.com/watch?v=bS1ixACATAw"
      },
      geometry: { type: "Point", coordinates: [35.112659, 31.401248] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L011",
        event_dates: "11 Aug 2020",
        location_name: "Khirbet al-Fakhit",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Residential tent that was home to seven people demolished.",
        sources:
          "https://www.btselem.org/media/2199#full;https://www.youtube.com/watch?v=c93QBOA90Uo"
      },
      geometry: { type: "Point", coordinates: [35.1086778, 31.4015524] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L012",
        event_dates: "24 Nov 2011",
        location_name: "Umm Fagarah",
        type: "Demolition",
        structure_types: "Residential; Agricultural; Other",
        notes:
          "Two houses, a mosque, a barn and a structure containing a generator demolished\n.",
        sources: "https://www.youtube.com/watch?v=ILiVe1WPafA"
      },
      geometry: { type: "Point", coordinates: [35.151173, 31.40267] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L013",
        event_dates: "6 Apr 2016",
        location_name: "Um El Kheir",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Six family dwellings demolished that housed 34 people. Three of the structures were donated by European aid agencies.",
        sources:
          "https://www.youtube.com/watch?v=xdElRTVgLRk;https://www.aljazeera.com/news/2016/4/12/surge-in-demolitions-leaves-more-palestinians-homeless;https://www.btselem.org/planning_and_building/20160407_three_days_of_demolitions"
      },
      geometry: { type: "Point", coordinates: [35.185152, 31.429091] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L014",
        event_dates: "12 Jun 2019",
        location_name: "Um al-Kheir",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Caravan housing a family of 10 demolished.",
        sources:
          "https://www.btselem.org/media/1732;https://www.youtube.com/watch?v=jrP09UjqYto;https://twitter.com/TogetherTuwani/status/1138810002683170816"
      },
      geometry: { type: "Point", coordinates: [35.184635, 31.428831] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L015",
        event_dates: "28 Feb 2019",
        location_name: "Al-Derat",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Cement home demolished, affecting one family.",
        sources:
          "https://www.facebook.com/mussa.qawasma/posts/10157029654360822;https://www.facebook.com/azmi.banat.3/videos/2184693064950280/;https://twitter.com/TogetherTuwani/status/1123581349561085953;http://poica.org/2019/05/%D8%A7%D9%84%D8%A7%D8%AD%D8%AA%D9%84%D8%A7%D9%84-%D9%8A%D9%87%D8%AF%D9%85-%D9%85%D8%B3%D9%83%D9%86%D8%A7%D9%8B-%D9%81%D9%8A-%D9%82%D8%B1%D9%8A%D8%A9-%D8%A7%D9%84%D8%AF%D9%8A%D8%B1%D8%A7%D8%AA-%D8%B4/"
      },
      geometry: { type: "Point", coordinates: [35.1553755, 31.4408708] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L016",
        event_dates: "27 Jan 2021",
        location_name: "Um Qusah",
        type: "Demolition",
        structure_types: "Religious",
        notes: "Mosque under construction demolished.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213285&community=&page=30;https://www.youtube.com/watch?v=sY9K9FRCDJo"
      },
      geometry: { type: "Point", coordinates: [35.22062, 31.449137] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L017",
        event_dates: "1 Dec 2020",
        location_name: "Tal Zif",
        type: "Demolition",
        structure_types: "Agricultural",
        notes:
          "The forces destroyed a cave and two pre-fabricated buildings used for agricultural purposes",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213195&community=&page=27;https://www.youtube.com/watch?v=HuxYr03IuIU"
      },
      geometry: { type: "Point", coordinates: [35.134768, 31.469174] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L018",
        event_dates: "21 Jul 2019",
        location_name: "Wadi al-Hummus",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Homes under construction demolished.",
        sources:
          "https://www.france24.com/en/20190722-israel-palestinian-homes-east-jerusalem-west-bank;https://www.gettyimages.com/detail/news-photo/this-picture-taken-on-july-22-2019-shows-israeli-security-news-photo/1157176940?adppopup=true;https://www.gettyimages.com/detail/news-photo/this-picture-taken-on-july-22-2019-shows-israeli-security-news-photo/1157177199?adppopup=true"
      },
      geometry: { type: "Point", coordinates: [35.25187, 31.717798] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L019",
        event_dates: "3 Sep 2018",
        location_name: "Al-Walaja",
        type: "Demolition",
        structure_types: "Residential; Other",
        notes: "Four homes demolished, affecting 21 people.",
        sources:
          "https://www.youtube.com/watch?v=W6tDBJKu3iI;https://www.gettyimages.com/detail/news-photo/israeli-forces-stand-guard-as-heavy-duty-machines-demolish-news-photo/1026436244?adppopup=true;https://lrcj.org/publication-3-1023.html"
      },
      geometry: { type: "Point", coordinates: [35.156468, 31.733039] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L020",
        event_dates: "15 Nov 2020",
        location_name: "Beit Safafa",
        type: "Construction",
        structure_types: "Residential",
        notes: "Machinery working on land slated for new illegal settlement.",
        sources:
          "https://twitter.com/Shepherds4Good/status/1327990664122888193;https://twitter.com/Shepherds4Good/status/1327990638374170624"
      },
      geometry: { type: "Point", coordinates: [35.198512, 31.747951] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L021",
        event_dates: "8 Jan 2020",
        location_name: "Jabal Al-Mukaber",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Two family homes demolished, affecting 15 people.",
        sources:
          "https://www.facebook.com/DaysofPalestine/videos/549559015447782;https://apaimages.photoshelter.com/image/I0000_OKTarSZFzI;http://www.palpress.net/?View=News&dep=10&id=4641"
      },
      geometry: { type: "Point", coordinates: [35.2311722, 31.7542134] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L022",
        event_dates: "4 Jul 2018",
        location_name: "Abu a-Nuwar",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Nine homes and three farm buildings demolished, affecting 62 people.",
        sources:
          "https://www.btselem.org/press_releases/20180704_who_is_the_real_criminal;https://www.youtube.com/watch?v=RBl8rd3PPII;https://www.gettyimages.com/detail/news-photo/israeli-police-secure-a-buldozer-demolishing-structures-at-news-photo/991457244?adppopup=true;https://lrcj.org/publication-3-898.html"
      },
      geometry: { type: "Point", coordinates: [35.292317, 31.763876] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L023",
        event_dates: "16 Feb 2021",
        location_name: "Ras al Amud",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Family home demolished, displacing four people.",
        sources:
          "https://twitter.com/Shepherds4Good/status/1361598599600214016;https://www.silwanic.net/index.php/article/news/78166"
      },
      geometry: { type: "Point", coordinates: [35.24379, 31.77111] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L024",
        event_dates: "20 Feb 2018",
        location_name: "Jabal Al-Baba",
        type: "Demolition",
        structure_types: "Residential",
        notes: "One structure demolished, leaving a 13-person family homeless.",
        sources:
          "https://www.facebook.com/watch/?v=1860029034016556;https://www.btselem.org/facing_expulsion_blog?nid=211885;https://www.youtube.com/watch?v=N3qz0upj9Yg"
      },
      geometry: { type: "Point", coordinates: [35.277994, 31.773564] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L025",
        event_dates: "24 Jul 2018",
        location_name: "Jabal al Baba",
        type: "Demolition",
        structure_types: "Other",
        notes:
          "Two structures dismantled, one of which was used as a day-care center and another that served as a community center.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?community=204528&nid=;https://www.youtube.com/watch?v=oqCL6K4glnw;https://twitter.com/QudsNen/status/1022018247326138368"
      },
      geometry: { type: "Point", coordinates: [35.276816, 31.773367] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L026",
        event_dates: "2 July 2020",
        location_name: "Al-Tur",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Family home demolished.",
        sources:
          "https://twitter.com/AlQastalps/status/1278705926917234688;https://twitter.com/PalinfoAr/status/1278713929594699776;https://www.gettyimages.com/detail/news-photo/relative-of-the-palestinian-shalalda-family-watches-as-an-news-photo/1228262537?adppopup=true;https://www.timesofisrael.com/denied-legal-building-permits-some-east-jerusalem-families-raze-their-own-homes/"
      },
      geometry: { type: "Point", coordinates: [35.247438, 31.779482] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L027",
        event_dates: "21 Nov 2018",
        location_name: "Shua'fat Refugee Camp",
        type: "Demolition",
        structure_types: "Commercial",
        notes: "18 storefronts and three gas stations demolished.",
        sources:
          "https://www.timesofisrael.com/jerusalem-municipality-demolishes-16-stores-in-shuafat-refugee-camp/;https://www.aljazeera.com/news/2018/11/22/shuafat-demolition-to-tighten-israels-control-over-jerusalem"
      },
      geometry: { type: "Point", coordinates: [35.246023, 31.809001] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L028",
        event_dates: "4 Jul 2018",
        location_name: "Khan al-Ahmar",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Preparation for forced removal of community.",
        sources:
          "https://twitter.com/publiclawcentre/status/1031909761393025024;https://www.btselem.org/communities_facing_expulsion/khan_al_ahmar_updates;https://www.youtube.com/watch?v=4vF1va-qa04"
      },
      geometry: { type: "Point", coordinates: [35.340963, 31.811623] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L029",
        event_dates: "4 Aug 2020",
        location_name: "Beit Hanina",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Demolition of family home, affecting seven people.",
        sources:
          "https://www.btselem.org/video/20200809_4_east_jerusalem_families_forced_to_demolish_their_homes_within_a_week#full;https://twitter.com/mohamedGaza23/status/1299406326586576904;https://www.silwanic.net/index.php/article/news/77927"
      },
      geometry: { type: "Point", coordinates: [35.220091, 31.828505] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L030",
        event_dates: "17 Mar 2021",
        location_name: "a-Nuwei’mah",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "One shack demolished as well as 10 tents and nine plastic water containers confiscated, affecting 11 families totaling 66 people.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213388;https://www.youtube.com/watch?v=6OjI3YxLxYY"
      },
      geometry: { type: "Point", coordinates: [35.439142, 31.892594] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L031",
        event_dates: "29 Dec 2020",
        location_name: "Arab Al-Zayed",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes: "Three homes demolished and 350 olive trees uprooted.",
        sources:
          "https://www.facebook.com/1581196052104475/posts/3041760096048056/;https://shehabnews.com/post/75320/%D8%A7%D9%84%D8%A7%D8%AD%D8%AA%D9%84%D8%A7%D9%84-%D9%8A%D9%82%D8%AA%D9%84%D8%B9-350-%D8%B4%D8%AC%D8%B1%D8%A9-%D8%B2%D9%8A%D8%AA%D9%88%D9%86-%D9%88%D9%8A%D9%87%D8%AF%D9%85-3-%D9%85%D8%B3%D8%A7%D9%83%D9%86-%D9%81%D9%8A-%D8%A3%D8%B1%D9%8A%D8%AD%D8%A7;https://www.facebook.com/RamallahNewsOfficialPage/posts/5036181863122880"
      },
      geometry: { type: "Point", coordinates: [35.427874, 31.896908] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L032",
        event_dates: "25 Nov 2020",
        location_name: "Fasayil a-Tahta",
        type: "Demolition",
        structure_types: "Residential; Agricultural; WASH",
        notes:
          "Multiple structures, including residential shacks, kitchens, toilets, and structures used for keeping livestock, demolished.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213317;https://www.youtube.com/watch?v=xzX0BKYu7RE&t=23s"
      },
      geometry: { type: "Point", coordinates: [35.436524, 32.0343465] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L033",
        event_dates: "28 Jan 2021",
        location_name: "Wadi-al-Ahmar",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Three tents housing two families of 13 in total demolished along with structures and equipment used for keeping livestock.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213308;https://www.youtube.com/watch?v=_akg6FQJP9U"
      },
      geometry: { type: "Point", coordinates: [35.435309, 32.064576] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L034",
        event_dates: "11 Oct 2018",
        location_name: "al-Jiftlik",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Pre-fabricated home along with three livestock paddocks demolished, affecting a family of three.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212160;https://www.youtube.com/watch?v=0YAaz9LhCBw;https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=0e1c06fa00c8e4d6189e16f757b752889&authkey=AZr4ZqcgMIuPk1oYg-2szxU&e=ZfcV9o;https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=05a8708c5c6614598b100a36af835024d&authkey=AXQPUeKtYHwvQv6bRAB63d0&e=G4oPqB"
      },
      geometry: { type: "Point", coordinates: [35.504697, 32.134478] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L035",
        event_dates: "20 Nov 2013",
        location_name: "al-Jiftlik",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Family home demolished, affecting its 10 residents.",
        sources:
          "https://twitter.com/PhotoBrut/status/1106213768156061696;https://corporateoccupation.org/2013/12/06/jcb-equipment-used-in-jordan-valley-home-demolition/"
      },
      geometry: { type: "Point", coordinates: [35.492169, 32.155484] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L036",
        event_dates: "26 Sep 2016",
        location_name: "Beit Dajan, Nablus",
        type: "Demolition",
        structure_types: "Agricultural",
        notes: "Agricultural structure demolished.",
        sources:
          "https://www.facebook.com/PalestineTV/videos/1233024136767578;https://twitter.com/qudsn/status/780381015151939584"
      },
      geometry: { type: "Point", coordinates: [35.384837, 32.187573] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L037",
        event_dates: "7 Jul 2021",
        location_name: "Khirbet Humsah",
        type: "Demolition",
        structure_types: "Residential; Agricultural; WASH",
        notes:
          "Thirteen tents and huts used as residences, 17 agricultural structures, and water infrastructure demolished, affecting nine families with a total of 61 members.",
        sources:
          "https://www.btselem.org/press_release/20210709_court_sanctioned_war_crime_committed_in_broad_daylight;https://www.youtube.com/watch?v=74qAGqDTjiQ;https://twitter.com/btselem/status/1412683865869668360;https://twitter.com/NRC_MiddleEast/status/1412716247033200643"
      },
      geometry: { type: "Point", coordinates: [35.489567, 32.218019] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L038",
        event_dates: "3, 8, 22 Feb 2021",
        location_name: "Khirbet Humsah",
        type: "Demolition",
        structure_types: "Residential; Agricultural; WASH",
        notes:
          "A series of demolitions in February 2021 resulted in the destruction of most of the community’s residential structures, livestock enclosures, and portable outhouses, affecting 74 people.",
        sources:
          "https://www.btselem.org/video/20210204_israeli_forces_once_again_confiscate_residential_tents_in_khirbet_humsah_3_feb_2021#full;https://www.btselem.org/facing_expulsion_blog?nid=213319;https://www.btselem.org/facing_expulsion_blog?nid=213333;https://twitter.com/AFP/status/1357294078384300032"
      },
      geometry: { type: "Point", coordinates: [35.487895, 32.219078] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L039",
        event_dates: "3 Nov 2020",
        location_name: "Khirbet Humsah",
        type: "Demolition",
        structure_types: "Residential; Agricultural; WASH",
        notes:
          "18 tents and sheds housing 11 families totaling 74 people demolished along with numerous structures used for keeping livestock, toilets, and water containers.",
        sources:
          "https://www.btselem.org/press_releases/20201104_number_of_palestinians_israel_left_homeless_hits_four_year_record_in_pandemic;https://www.972mag.com/demolition-west-bank-jordan-valley/;https://www.facebook.com/OxfamOPTI/videos/416412346135772"
      },
      geometry: { type: "Point", coordinates: [35.482972, 32.226914] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L040",
        event_dates: "11 Oct 2018",
        location_name: "Al-Hadidiyah",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Three huts demolished that housed a family of eight, along with a paddock and two livestock pens.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212160&community=&page=30;https://www.youtube.com/watch?v=0YAaz9LhCBw"
      },
      geometry: { type: "Point", coordinates: [35.497186, 32.243508] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L041",
        event_dates: "13 Oct 2016",
        location_name: "Ras Ahmar, Tubas",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "10 homes and 17 livestock pens demolished affecting nine families and leaving 24 people homeless.",
        sources:
          "https://www.btselem.org/arabic/planning_and_building/20161009_demolitions;https://www.youtube.com/watch?v=0Zhi7TSlPhg;http://poica.org/2016/10/%D9%87%D8%AF%D9%85-%D8%AE%D9%8A%D8%A7%D9%85-%D8%B3%D9%83%D9%86%D9%8A%D8%A9-%D9%88%D8%B2%D8%B1%D8%A7%D8%B9%D9%8A%D8%A9-%D8%A3%D8%AF%D8%AA-%D8%A5%D9%84%D9%89-%D8%AA%D8%B4%D8%B1%D9%8A%D8%AF-32-%D9%81/"
      },
      geometry: { type: "Point", coordinates: [35.468514, 32.254706] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L042",
        event_dates: "20 Apr 2020",
        location_name: "Sabastiya, Nablus",
        type: "Demolition",
        structure_types: "Commercial; Residential",
        notes:
          "Tourism facility and mobile caravan demolished in Sebastiya and Burqa.",
        sources:
          "https://twitter.com/alrayps/status/1252170515155910656;https://qudsn.net/post/175045/%D8%A7%D9%84%D8%A7%D8%AD%D8%AA%D9%84%D8%A7%D9%84-%D9%8A%D9%87%D8%AF%D9%85-%D9%85%D9%86%D8%B4%D8%A3%D8%AA%D9%8A%D9%86-%D8%B4%D9%85%D8%A7%D9%84-%D8%BA%D8%B1%D8%A8-%D9%86%D8%A7%D8%A8%D9%84%D8%B3?__cf_chl_jschl_tk__=741f990a703188e6eb0dbdaa370f777949ce7b19-1621286611-0-Acz3KfzUu48GdwQXQZWdDnBqoPEcYKY6FvK7Wz_9SSGoG00nx0C8flo2wewxl8XsZJJVTdWLzvG3MiquLNCZpCaCdKmy6yjcehiEwbyflud77v7Jc7G8YEi879RimCGTXep0-K71XO50xRYySsD3d_pjxXSe5WTPvTXbqAE0oBgD1xdJjAmFZJjm4IA-ID50X8iKr0VxCYUPEA8NPjeml2QBEkDniFbvx003x5-vlr6bFLl_zb2G8z5UN1WhqzPGQmu04bX8fa7pCIUATfvwwAbuX3FAMIOB0QKKesdN_sBXcsPLEUpzbz9mYiJo_V52RscS6w0KA4JBv5nElc0uHw76K84WZzVzbFy9UKPalo2rPXQibEqVSbosRi0e34Py_eGwbMu4uxGXXeRHY6xzWBzj1jWRNYEd8eCa1gI_m9bEXK2Tp77rY7VMqyD5THqb5lUBjriPHQdJkYIJQcKg_qveclWO5KXO_Mc4g4IVdDVja8l3mDQLZF1Cf6GfS9TZUgOpXlaBJLSyOC8OrggZWG7xq9dM0fV-V0ZXZitcXU9xp7t3kC1pUehyKSX6CuZ20Cu787C8WaO2m0CsAtJsvK23Vmuv0MbfiiUbIX04CFDazfStMN5kJjMk4tbMgREMcYHbkINqt2U62APFBMQp4lX4IE2Tv_4N1GZihSXxjVtr;https://www.dooz.ps/p/144039"
      },
      geometry: { type: "Point", coordinates: [35.1938, 32.289] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L043",
        event_dates: "12 Jun 2019",
        location_name: "Khirbet a-Ras al-Ahmar",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Six tents housing two families with a total of 15 members demolished along with six tents used as livestock pens.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212459;https://www.youtube.com/watch?v=EW6F6o2qc-c"
      },
      geometry: { type: "Point", coordinates: [35.4518603, 32.2776341] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L044",
        event_dates: "27 Jan 2021",
        location_name: "Khirbet ‘Einun",
        type: "Demolition",
        structure_types: "Agricultural; Other",
        notes: "3,000 forest trees and 130 olive and almond trees uprooted.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213286;https://www.youtube.com/watch?v=-BiV5ygW6-4"
      },
      geometry: { type: "Point", coordinates: [35.410561, 32.298086] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L046",
        event_dates: "8 Feb 2021",
        location_name: "Khirbet Yarza",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes:
          "Two pre-fabricated homes serving two families numbering 11 people demolished along with a shack used to house livestock.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=213317;https://www.youtube.com/watch?v=7jPut-EJeMo;https://www.lrcj.org/media-3-2366.html"
      },
      geometry: { type: "Point", coordinates: [35.42844, 32.318487] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L047",
        event_dates: "7 Sep 2016",
        location_name: "Aqaba, Tubas",
        type: "Demolition",
        structure_types: "Residential; Agricultural",
        notes: "Residential and agricultural buildings destroyed.",
        sources:
          "https://www.facebook.com/QudsN/posts/1255643141179251/;https://twitter.com/qudsn/status/773472170672553984"
      },
      geometry: { type: "Point", coordinates: [35.349682, 32.350489] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L048",
        event_dates: "7 Feb 2017",
        location_name: "Kardala, Tubas",
        type: "Demolition",
        structure_types: "Agricultural",
        notes: "Structure used to keep livestock destroyed.",
        sources:
          "https://www.facebook.com/QudsN/posts/1425236177553279;http://poica.org/2017/02/%D9%87%D8%AF%D9%85-%D8%A8%D8%B1%D9%83%D8%B3%D8%A7%D8%AA-%D9%88%D8%AD%D8%B8%D8%A7%D8%A6%D8%B1-%D8%B2%D8%B1%D8%A7%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D9%85%D9%86%D8%B7%D9%82%D8%A9-%D8%A7%D9%84%D8%A3%D8%BA/"
      },
      geometry: { type: "Point", coordinates: [35.492068, 32.378244] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L049",
        event_dates: "5 Feb 2019",
        location_name: "Bardala, Tubas",
        type: "Demolition",
        structure_types: "Agricultural",
        notes: "450 olive trees uprooted.",
        sources:
          "https://twitter.com/PalestineVideo/status/1092755874722922496;https://twitter.com/PalMissionUK/status/1093112821582307333;http://english.pnn.ps/2019/02/05/iof-uproot-450-olive-trees-in-bardala-northern-west-bank/"
      },
      geometry: {
        type: "Point",
        coordinates: [35.480698700000012, 32.3862146]
      }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L050",
        event_dates: "24 Jun 2020",
        location_name: "Bardala, Tubas",
        type: "Demolition",
        structure_types: "Agricultural",
        notes: "70 olive trees uprooted.",
        sources:
          "https://www.btselem.org/video/20200624_ca_uproots_olive_trees_in_bardala_jordan_valley#full;https://twitter.com/alhaq_org/status/1277490952228278274;https://twitter.com/MarwaLahouimel/status/1275763929998864385"
      },
      geometry: { type: "Point", coordinates: [35.479568, 32.385573] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L051",
        event_dates: "9 Aug 2020",
        location_name: "Farasin",
        type: "Demolition",
        structure_types: "Residential",
        notes: "Cave serving as home to a family of three demolished.",
        sources:
          "https://www.youtube.com/watch?v=5HFnwredPSE&t=5s;https://www.timesofisrael.com/israel-issues-demolition-notice-for-palestinian-cave-home/;https://twitter.com/falasteen47/status/1292841292268003332?lang=en;https://www.youtube.com/watch?v=Stj0MLkI1xs"
      },
      geometry: { type: "Point", coordinates: [35.109302, 32.425766] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L053",
        event_dates: "25 Nov 2020",
        location_name: "Masafer Yatta",
        type: "Demolition",
        structure_types: "WASH",
        notes: "Water tanks and water lines destroyed.",
        sources:
          "https://www.btselem.org/press_releases/20201126_44_palesinian_homes_demolished_israel_commits_crime_and_paints_palestinians_as_the_offenders;https://www.youtube.com/watch?v=tIel1attV3g;https://twitter.com/turkistantuzbah/status/1331720998983495686;https://twitter.com/ap_awire/status/1331571189656002560"
      },
      geometry: { type: "Point", coordinates: [35.180833, 31.38] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L054",
        event_dates: "24 Dec 2019",
        location_name: "Maghayir Al Abeed",
        type: "Demolition",
        structure_types: "Residential",
        notes:
          "Three cinder-block homes serving three families totaling 12 members demolished.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212694;https://twitter.com/TogetherTuwani/status/1202506207220654081;https://twitter.com/TogetherTuwani/status/1209533210121637888"
      },
      geometry: {
        type: "Point",
        coordinates: [35.176812551862547, 31.396910623299583]
      }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L055",
        event_dates: "11 Sep 2019",
        location_name: "Al-Mufaqarah",
        type: "Demolition",
        structure_types: "Residential; WASH",
        notes:
          "Three pre-fabricated buildings and a tent that housed four families, 18 people in total, demolished along with a water pipe bringing water to the area.",
        sources:
          "https://www.btselem.org/facing_expulsion_blog?nid=212514;https://palsolidarity.org/2019/09/israeli-apartheid-in-masafer-yatta-raids-demolitions-arrests-and-beatings/;https://twitter.com/ManPalestine/status/1172072362457608192;https://www.gettyimages.com/detail/news-photo/this-picture-taken-on-september-11-2019-shows-israeli-news-photo/1167368873?adppopup=true"
      },
      geometry: { type: "Point", coordinates: [35.150786, 31.402933] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "L056",
        event_dates: "31 Jul 2019",
        location_name: "Jawwaya",
        type: "Demolition",
        structure_types: "WASH",
        notes: "Water pipelines destroyed.",
        sources: "https://twitter.com/TogetherTuwani/status/1156630039347302403"
      },
      geometry: { type: "Point", coordinates: [35.152151, 31.419284] }
    }
  ]
};
